/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitEntityRefreshQueries
 */
export interface MonitEntityRefreshQueries {
    /**
     * 
     * @type {string}
     * @memberof MonitEntityRefreshQueries
     */
    entity_type?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityRefreshQueries
     */
    reason?: string;
}

/**
 * Check if a given object implements the MonitEntityRefreshQueries interface.
 */
export function instanceOfMonitEntityRefreshQueries(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitEntityRefreshQueriesFromJSON(json: any): MonitEntityRefreshQueries {
    return MonitEntityRefreshQueriesFromJSONTyped(json, false);
}

export function MonitEntityRefreshQueriesFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitEntityRefreshQueries {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entity_type': !exists(json, 'entity_type') ? undefined : json['entity_type'],
        'reason': !exists(json, 'reason') ? undefined : json['reason'],
    };
}

export function MonitEntityRefreshQueriesToJSON(value?: MonitEntityRefreshQueries | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entity_type': value.entity_type,
        'reason': value.reason,
    };
}

